import { render, staticRenderFns } from "./SalesDashboard.vue?vue&type=template&id=a84a4816"
import script from "./SalesDashboard.vue?vue&type=script&lang=js"
export * from "./SalesDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a84a4816')) {
      api.createRecord('a84a4816', component.options)
    } else {
      api.reload('a84a4816', component.options)
    }
    module.hot.accept("./SalesDashboard.vue?vue&type=template&id=a84a4816", function () {
      api.rerender('a84a4816', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Sales/components/SalesDashboard.vue"
export default component.exports